import App from 'app/app.js';

function LtChooseSpecOrderDrawerCtrl($scope, ShoppingCartStore) {
  this.init = function () {
    this.visible = true;
  };

  this.selectPayOnly = function () {
    this.close();
    $scope.onSelectPayOnly();
  };

  this.selectOrder = function () {
    this.close();
    $scope.onSelectOrder();
  };

  this.cancelOrder = function () {
    this.close();
    ShoppingCartStore.removeSubject(ShoppingCartStore.getCurrentSubject().id, true);
    $scope.cancelChooseSpec();
  };

  this.close = function () {
    this.visible = false;
  };
}

App.controller('LtChooseSpecOrderDrawerCtrl', ['$scope', 'ShoppingCartStore', LtChooseSpecOrderDrawerCtrl]);
